<template>
  <div class="req-status">
    <p v-if="!data || data.length < 1" class="no_data">
      {{ $lange == "en" ? "No Data" : "暂无数据" }}
    </p>
    <e-charts
      v-else
      style="width: 100%"
      :options="options"
      auto-resize
    ></e-charts>
  </div>
</template>

<script>
// 请求数据-按状态

import ECharts from "../components/Charts.vue";
import "echarts/lib/chart/pie";
import "echarts/lib/component/legendScroll";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import theme from "./theme";

export default {
  name: "RequestStatusPie",
  components: { ECharts },
  props: {
    data: {
      type: Array,
    },
  },
  data() {
    return {
      constants: {
        processed: this.$lange == "en" ? "Processing" : "处理中",
        observation: this.$lange == "en" ? "Monitoring" : "观察中",
        finish: this.$lange == "en" ? "Completed" : "已完成",
        close: this.$lange == "en" ? "Closed" : "已关闭",
        cancel: this.$lange == "en" ? "Cancel" : "已取消",
      },
    };
  },
  computed: {
    options() {
      // const seriesData = this.data.map((item) => ({
      //   name: this.constants[item.code],
      //   value: item.value,
      // }));
      const seriesData = Object.keys(this.constants).map((i) => {
        const data = this.data.find((d) => d.code === i);
        if (!data)
          return {
            name: this.constants[i],
            value: null,
          };
        return {
          name: this.constants[i],
          value: data.value,
        };
      });
      return {
        ...theme,
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          top: 6,
        },
        series: [
          {
            name:   this.$lange == "en" ? "Status" : "状态",
            type: "pie",
            radius: "55%",
            data: seriesData,

            label: {
              formatter: "{d}%",
            },
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.no_data {
  text-align: center;
  color: #86898f;
  /* align-self: center; */
  transform: translateY(-50%);
  position: relative;
  top: 50%;
  left: 0;
}
</style>
